<div class="cluster-marker" [ngClass]="clusterColor()">
  {{ size() }}
</div>
